import { render, staticRenderFns } from "./TenancySubscription.vue?vue&type=template&id=012ce1ba&scoped=true&"
import script from "./TenancySubscription.vue?vue&type=script&lang=js&"
export * from "./TenancySubscription.vue?vue&type=script&lang=js&"
import style0 from "./TenancySubscription.vue?vue&type=style&index=0&id=012ce1ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012ce1ba",
  null
  
)

export default component.exports